
import WidgetDefaultNuxt from '../default/nuxt.vue';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import defaultValues from '@xd-rocket/attributes/src/attributes/carousel/default';

import { handleSetTransition, handleSetTranslate } from './custom-swiper-flip';

export default {
  name: 'WidgetCarouselNuxt',
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  extends: WidgetDefaultNuxt,
  data: function () {
    const carousel = this.values.carousel || defaultValues.carousel;
    const { viewStyle, slides, slidesPerView } = carousel;
    let carouselClass = [viewStyle, 'poster-swiper'];
    if (slidesPerView === 'auto') {
      if (
        viewStyle === 'slide' ||
        viewStyle === 'displacement' ||
        viewStyle === 'centered' ||
        viewStyle === 'coverflow'
      ) {
        carouselClass.push('swiper-per-view-auto');
      }
    }
    if (viewStyle === 'flip') {
      carouselClass.push('swiper-container-flip', 'swiper-container-3d');
    }
    if (carousel.loop) {
      carouselClass.push('swiper-container-loop');
    }

    return {
      widgetClassName: 'widget-carousel',
      swiperOptions: this.getSwiperOptions(carousel),
      swiperStyle: this.getSwiperStyle(carousel),
      slides: this.getLocaleValue(slides),
      carouselClass,
      localePath: [{ key: 'slides', value: slides }],
      lastPlay: carousel.autoplay, // 用于记录隐藏元素时的播放状态
      hiddenStatus: 0, // 0 未隐藏 1 本身隐藏 2 父级隐藏
    };
  },
  mounted() {
    // 垂直模式下，判断各滑块是否有滚动条
    const { swiperOptions } = this;

    this.hiddenStatus = this.getHiddenStatus();
    this.observeVisible();

    // 目前只支持垂直滑动和渐变检测
    if (
      swiperOptions.direction === 'vertical' &&
      (swiperOptions.effect === 'slide' || swiperOptions.effect === 'fade')
    ) {
      const $swiper = this.$refs.rocketCarousel?.$swiper;
      if ($swiper) {
        let startScroll, touchStart, touchCurrent;
        $swiper.slides.on(
          'touchstart',
          function (e) {
            startScroll = this.scrollTop;
            touchStart = e.targetTouches[0].pageY;
          },
          true
        );
        $swiper.slides.on(
          'touchmove',
          function (e) {
            touchCurrent = e.targetTouches[0].pageY;
            var touchesDiff = touchCurrent - touchStart; //判断滑动方向
            var slide = this;
            var onlyScrolling =
              slide.scrollHeight > slide.offsetHeight && //如果滑动到存在滚动条的结构时，此判断为true
              ((touchesDiff < 0 && startScroll === 0) || //从顶部滚动到底部
                (touchesDiff > 0 &&
                  startScroll === slide.scrollHeight - slide.offsetHeight) || //从底部滚动到顶部
                (startScroll > 0 &&
                  startScroll < slide.scrollHeight - slide.offsetHeight)); //从中间开始
            if (onlyScrolling) {
              e.stopPropagation(); //终止事件在传播过程的捕获、目标处理或起泡阶段进一步传播。
            }
          },
          true
        );
      }
    }
  },
  beforeDestroy() {
    let swiper = this.$refs.rocketCarousel.$swiper;
    if (swiper) {
      swiper.destroy();
    }
    if (this.watchImages) {
      this.watchImages.forEach((imgId) => {
        this.$bus.$off(
          'rocket:image:lazy-load-success:' + imgId,
          this.handleImageLazyLoad
        );
      });
    }
    if (this.observer) this.observer.disconnect();
  },
  methods: {
    initEvent() {
      this.rocketOn('rocket:carousel:refresh', true, this.handleRefresh);
      this.rocketOn('rocket:carousel:start', true, this.handlePlay);
      this.rocketOn('rocket:carousel:stop', true, this.handleStop);
      this.rocketOn('rocket:carousel:slideNext', true, this.handleSlideNext);
      this.rocketOn('rocket:carousel:slidePrev', true, this.handleSlidePrev);
      this.rocketOn('rocket:carousel:slideTo', true, this.handleSlideTo);
    },
    getHiddenStatus() {
      if (getComputedStyle(this.$el).display === 'none') return 1;
      else if (!this.$el.offsetParent) return 2;
      return 0;
    },
    observeVisible() {
      this.observer = new IntersectionObserver(
        (entries) => {
          this.handleVisibleChange(entries[0].isIntersecting);
        },
        { threshold: 0 }
      );
      this.observer.observe(this.$el);
    },
    getSwiperOptions(carousel) {
      const {
        viewStyle,
        loop,
        loopDelay,
        bulletClickable,
        direction,
        speed,
        mousewheel,
        slideToClickedSlide,
        slidesPerView,
        slidesPerColumn,
        slidesPerColumnFill,
        scrollbarDragSize,
        scrollbarSnap,
        scrollbarHide,
        scrollbarDraggable,
        rotate,
        depth,
        stretch,
        threshold,
        longSwipesRatio,
        slideShadows,
        shadow,
        autoHeight,
        autoplay,
      } = carousel;
      let self = this;
      let option = {
        slidesPerView,
        slidesPerColumn,
        slidesPerColumnFill,
        slidesPerGroup: 1,
        loop,
        roundLengths: true,
        touchEventsTarget: 'wrapper',
        direction,
        speed: +speed,
        mousewheel,
        autoplay: autoplay
          ? {
              delay: loopDelay,
              stopOnLastSlide: false,
              disableOnInteraction: false,
              enabled: false,
            }
          : false,
        observer: true,
        observeParents: true,
        slideToClickedSlide,
        autoHeight,
        on: {},
        threshold,
        longSwipesRatio,
      };
      if (viewStyle === 'scroll') {
        option.freeMode = true;
        option.slidesPerView = 'auto';
        option.loop = false;
      } else {
        option.effect = viewStyle;
        if (
          viewStyle === 'full' ||
          viewStyle === 'displacement' ||
          viewStyle === 'centered'
        ) {
          option.effect = 'slide';
        }
        if (viewStyle === 'flip') {
          // TODO 点击指示器切换时 未依次切换时中间过渡元素会闪现，动画播放时禁止点击切换 (swiper bug)
          // 暂不支持 loop
          option = {
            ...option,
            effect: 'slide',
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            spaceBetween: 0,
            virtualTranslate: true,
            preventInteractionOnTransition: true,
            loopedSlides: 1,
            on: {
              setTranslate: handleSetTranslate,
              setTransition: handleSetTransition,
            },
          };
        } else if (viewStyle === 'centered') {
          option.centeredSlides = true;
        } else if (viewStyle === 'fade') {
          option.fadeEffect = {
            crossFade: true,
          };
        } else if (viewStyle === 'cube') {
          option.cubeEffect = {
            slideShadows,
            shadow,
            // shadowOffset: 100,
            // shadowScale: 0.8,
          };
          if (option.loop) {
            option.loopedSlides = 3; // 修复循环时元素重叠的问题
            option.slidesPerView = 1;
          }
        } else if (viewStyle === 'coverflow') {
          option.centeredSlides = true;
          option.coverflowEffect = {
            rotate,
            stretch,
            depth,
            slideShadows,
          };
        }
        option.pagination = {
          el: '.swiper-carousel-' + this.id + '>.swiper-pagination',
          clickable: bulletClickable,
        };

        option.navigation = {
          nextEl: '.' + this.values.id + '>.swiper-button-next',
          prevEl: '.' + this.values.id + '>.swiper-button-prev',
        };
        if (option.loop) {
          option.on.init = function () {
            if (viewStyle === 'flip') {
              handleSetTranslate.call(this);
            }
            self.watchLoopImages();
            if (option.centeredSlides) self.loadVisibleImageOfLoop(this);
          };
        }
      }
      option.scrollbar = {
        el: '.swiper-carousel-' + this.values.id + '>.swiper-scrollbar',
        hide: scrollbarHide,
        dragSize: scrollbarDragSize,
        draggable: scrollbarDraggable,
        snapOnRelease: scrollbarSnap,
      };
      return Object.freeze(option);
    },
    getSwiperStyle(carousel) {
      const { speed } = carousel;
      return {
        '--rocket-carousel-speed': `${speed}ms`,
      };
    },
    handleVisibleChange(status) {
      if (!this.lastPlay) return; // 状态改变前是暂停状态，不需要再重启播放
      if (status) {
        this.handlePlay();
      } else {
        this.handleStop(true);
      }
      let hiddenStatus = this.getHiddenStatus();
      if (!status) {
        // 显隐状态改变
        if (!!hiddenStatus !== !!this.hiddenStatus) {
          // 元素受父元素影响显示隐藏时
          // 修复父级元素隐藏显示时，vue-swiper 的 updated 未触发更新，导致的自动播放异常问题
          if (hiddenStatus !== 1 && this.hiddenStatus !== 1) {
            this.$refs.rocketCarousel.$swiper.update();
          }
        }
      }
      this.hiddenStatus = hiddenStatus;
    },
    handleRefresh() {
      let swiper = this.$refs.rocketCarousel?.$swiper;
      if (swiper) {
        // swiper.update();
        if (this.swiperOptions.loop) {
          setTimeout(() => {
            swiper.loopDestroy();
            swiper.loopCreate();
          }, 0);
        }
      }
    },
    handlePlay() {
      let swiper = this.$refs.rocketCarousel?.$swiper;
      if (swiper) swiper.autoplay.start();
      this.lastPlay = true;
    },
    handleStop(auto = false) {
      let swiper = this.$refs.rocketCarousel?.$swiper;
      if (swiper) {
        swiper.autoplay.stop();
        if (!auto) {
          // 不是被隐藏时的停止命令，记录状态
          this.lastPlay = false;
        }
      }
    },
    handleSlideNext() {
      let swiper = this.$refs.rocketCarousel?.$swiper;
      if (swiper) swiper.slideNext();
    },
    handleSlidePrev() {
      let swiper = this.$refs.rocketCarousel?.$swiper;
      if (swiper) swiper.slidePrev();
    },
    handleSlideTo(i) {
      let swiper = this.$refs.rocketCarousel?.$swiper;
      if (swiper) {
        if (this.swiperOptions.loop) {
          swiper.slideToLoop(i);
        } else {
          swiper.slideTo(i);
        }
      }
    },
    handleSlideChange() {
      let swiper = this.$refs.rocketCarousel.$swiper;
      if (swiper) {
        this.rocketEmit('rocket:carousel:slideChange', true, swiper.realIndex);
        if (this.swiperOptions.loop) {
          let loopedSlides = swiper.loopedSlides;
          if (
            swiper.activeIndex < loopedSlides ||
            swiper.activeIndex >= swiper.slides.length - loopedSlides
          ) {
            swiper.slideToLoop(swiper.realIndex, 0, 0);
            return;
          }
        }
      }
    },
    handleSlideStart() {
      let swiper = this.$refs.rocketCarousel.$swiper;
      if (swiper) {
        this.rocketEmit('rocket:carousel:slideStart', true, swiper.realIndex);
      }
    },
    // 当循环的轮播图中有图片懒加载完成时
    handleImageLazyLoad(e) {
      const imageId = e.id;
      if (this.loadImages.has(imageId)) return;
      this.loadImages.add(imageId);
      let k1 = `#${imageId}.swiper-slide-duplicate`; // 图片直接用于滚动
      let k2 = `.swiper-slide-duplicate #${imageId}`; // 图片被容器包围
      if (this.$el.querySelector(k1) || this.$el.querySelector(k2)) {
        const swiper = this.$refs.rocketCarousel.$swiper;
        swiper.loopDestroy();
        swiper.loopCreate();
      }
    },
    // 居中并开启循环时，初始化后检测可视区域循环元素中的图片，并主动加载
    loadVisibleImageOfLoop(swiper) {
      let cls = swiper.params.slideDuplicateClass;
      let slides = swiper.slides;
      let wantImages = new Set();
      let { left, right, top, bottom } = this.$el.getBoundingClientRect();
      slides.each((i, o) => {
        const isDup = o.classList.contains(cls);
        if (!isDup) return;

        let rect = o.getBoundingClientRect();
        if (
          rect.left > right ||
          rect.right < left ||
          rect.top > bottom ||
          rect.bottom < top
        )
          return;

        const $imgs = o.querySelectorAll('.widget-image');
        $imgs.forEach((item) => {
          let imgNodeId = item.getAttribute('node-id');
          let id = item.getAttribute('id');
          if (!wantImages.has(id)) {
            wantImages.add(id);
            if (!imgNodeId) imgNodeId = id;
            this.$bus.$emit(
              'rocket:node:trigger:' + imgNodeId,
              'rocket:image:lazy-load',
              { id }
            );
          }
        });
      });
    },
    watchLoopImages() {
      // 顶层循环轮播图开启监听内部元素懒加载更新事件
      if (!this.$el.closest('.swiper-container-loop')) {
        let $imgs = this.$el.querySelectorAll('.widget-image');
        let imgSet = new Set();
        this.loadImages = new Set(); // 已加载的图片
        $imgs.forEach((item) => {
          let imgId = item.getAttribute('node-id');
          if (!imgId) imgId = item.getAttribute('id');
          if (!imgSet.has(imgId)) {
            imgSet.add(imgId);
            this.$bus.$on(
              'rocket:image:lazy-load-success:' + imgId,
              this.handleImageLazyLoad
            );
          }
        });
        this.watchImages = [...imgSet];
      }
    },
  },
};
